import NewAgreement from 'client/components/entities/Agreement/Agreement'
import AudioNew from 'client/components/entities/Audio/AudioNew'
import { BookingCalendar } from 'client/components/entities/BookingCalendar'
import { Body } from 'client/components/entities/body'
import ButtonNew from 'client/components/entities/button-new'
import Carousel from 'client/components/entities/Carousel'
import Checkbox from 'client/components/entities/Checkbox'
import Column from 'client/components/entities/Column'
import ContentBox from 'client/components/entities/ContentBox'
import ContentTable from 'client/components/entities/ContentTable'
import Countdown from 'client/components/entities/Countdown'
import Coupon from 'client/components/entities/coupon'
import FacebookComments from 'client/components/entities/FacebookComments'
import Faq from 'client/components/entities/Faq'
import FieldNew from 'client/components/entities/field-new/field-new'
import Headline from 'client/components/entities/Headline'
import ImageNew from 'client/components/entities/Image/Image'
import NewLanguageSwitcher from 'client/components/entities/LanguageSwitcher/NewLanguageSwitcher'
import Menu from 'client/components/entities/Menu/Menu'
import NewBulletList from 'client/components/entities/NewBulletList'
import NewHorizontalLine from 'client/components/entities/NewHorizontalLine'
import OfferThankYouOrderSummaryNew from 'client/components/entities/OfferThankYouOrderSummaryNew'
import PaymentButtonNew from 'client/components/entities/PaymentButton/PaymentButtonNew'
import PopupNew from 'client/components/entities/popup-new'
import { PriceElement } from 'client/components/entities/price-element'
import NewRawHtml from 'client/components/entities/RawHtml/NewRawHtml'
import Recaptcha from 'client/components/entities/Recaptcha'
import Row from 'client/components/entities/Row'
import ReadOnlyRow from 'client/components/entities/Row/components/ReadOnlyRow'
import Section from 'client/components/entities/Section'
import ShippingFees from 'client/components/entities/ShippingFees'
import SurveyNew from 'client/components/entities/Survey/Survey'
import TextNew from 'client/components/entities/Text/Text'
import TwitterTweetButton from 'client/components/entities/TwitterTweetButton'
import VideoNew from 'client/components/entities/VideoNew'
import { BlogContentPlaceholder } from 'client/pages/blog/entities/BlogContentPlaceholder'
import CustomerTypeNew from 'client/pages/offer/entities/CustomerType'
import OfferPriceNew from 'client/pages/offer/entities/OfferPrice'
import OrderBump from 'client/pages/offer/entities/order-bump'
import PaymentMethod from 'client/pages/offer/entities/PaymentMethod'
import Product from 'client/pages/offer/entities/Product'
import { ColumnInterface } from 'common/components/entities/Column/types/ColumnInterface'
import MenuInterface from 'common/components/entities/Menu/types/MenuInterface'
import { RowInterface } from 'common/components/entities/Row/types/RowInterface'
import { SectionInterface } from 'common/components/entities/Section/types/SectionInterface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { AudioInterface } from 'common/types/entities/AudioInterface'
import { BlogContentPlaceholderInterface } from 'common/types/entities/BlogContentPlaceholderInterface'
import { BodyInterface } from 'common/types/entities/body-interface'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { CheckboxInterface } from 'common/types/entities/CheckboxInterface'
import { ContentBoxInterface } from 'common/types/entities/ContentBoxInterface'
import { ContentTableInterface } from 'common/types/entities/ContentTableInterface'
import { CountdownInterface } from 'common/types/entities/CountdownInterface'
import { CustomerTypeInterface } from 'common/types/entities/CustomerTypeInteface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { FacebookCommentsInterface } from 'common/types/entities/FacebookCommentsInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { HeadlineInterface } from 'common/types/entities/HeadlineInterface'
import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { LanguageSwitcherInterface } from 'common/types/entities/LanguageSwitcherInterface'
import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PaymentButtonInterface } from 'common/types/entities/PaymentButtonInterface'
import { PaymentMethodInterface } from 'common/types/entities/PaymentMethodInterface'
import ProductEntityInterface from 'common/types/entities/ProductInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import { RawHtmlInterface } from 'common/types/entities/RawHtmlInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { ShippingFeesInterface } from 'common/types/entities/ShippingFeesInterface'
import { SurveyInterface } from 'common/types/entities/SurveyInterface'
import { TextInterface } from 'common/types/entities/TextInterface'
import { TwitterTweetButtonInterface } from 'common/types/entities/TwitterTweetButtonInterface'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import React from 'react'
import { WebsiteButton } from 'src/editor/shared/entities/website-button'
import { WebsiteFooter } from 'src/editor/shared/entities/website-footer'
import { WebsiteHeader } from 'src/editor/shared/entities/website-header'
import { WebsiteLayoutBody } from 'src/editor/shared/entities/website-layout-body'
import { WebsiteLogo } from 'src/editor/shared/entities/website-logo'
import { WebsitePageBody } from 'src/editor/shared/entities/website-page-body'
import { AgreementInterface } from 'src/shared/entities/agreement/agreement.schema'
import { CarouselInterface } from 'src/shared/entities/carousel/carousel.schema'
import { CouponInterface } from 'src/shared/entities/coupon/coupon.schema'
import { FaqInterface } from 'src/shared/entities/faq/faq.schema'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'
import { WebsiteButtonInterface } from 'src/shared/types/entities/website-button-interface'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
import {
  WebsiteFooterInterface,
  WebsiteHeaderInterface,
  WebsiteLayoutBodyInterface,
  WebsitePageInterface,
} from 'src/shared/types/website-entities'

export type AdditionalProps = {
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

export const createWebsiteEntityElement = (
  entity: EntityInterface | OldEntityInterface | BaseEntityNewInterface,
  additionalProps: AdditionalProps,
) => {
  const { type, id } = entity

  switch (type) {
    case EntityTypeEnum.Body: {
      return (
        <Body
          entity={entity as BodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Section:
      return (
        <Section
          entity={entity as SectionInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Row: {
      if ((entity as RowInterface).isReadOnly) {
        return (
          <ReadOnlyRow entity={entity as RowInterface} key={`entity-${id}`} />
        )
      }
      return (
        <Row
          entity={entity as RowInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Column:
      return (
        //@ts-expect-error @TODO harmonize interfaces
        <Column
          entity={entity as ColumnInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Headline:
      return (
        <Headline
          entity={entity as HeadlineInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BulletList:
      return (
        <NewBulletList
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BookingCalendar:
      return (
        <BookingCalendar
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Image:
      return (
        <ImageNew
          entity={entity as ImageInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonNew
          entity={entity as ButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Field:
      return (
        <FieldNew
          entity={entity as FieldInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Popup:
      return (
        <PopupNew
          entity={entity as PopupInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Video:
      return (
        <VideoNew
          entity={entity as VideoInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OfferPrice:
      return (
        <OfferPriceNew
          entity={entity as OfferPriceInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Product:
      return (
        <Product
          entity={entity as ProductEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.RawHtml:
      return (
        <NewRawHtml
          entity={entity as RawHtmlInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OrderBump:
      return (
        //@ts-expect-error @TODO harmonize interfaces
        <OrderBump entity={entity} {...additionalProps} key={`entity-${id}`} />
      )
    case EntityTypeEnum.Checkbox:
      return (
        <Checkbox
          entity={entity as CheckboxInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OrderSummary:
      return (
        <OfferThankYouOrderSummaryNew
          entity={entity as EntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Coupon:
      return (
        <Coupon
          key={`entity-${id}`}
          entity={entity as CouponInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogContentPlaceholder:
      return (
        <BlogContentPlaceholder
          entity={entity as BlogContentPlaceholderInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Menu:
      return (
        <Menu
          entity={entity as MenuInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.LanguageSwitcher:
      return (
        <NewLanguageSwitcher
          entity={entity as LanguageSwitcherInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.TwitterTweetButton:
      return (
        <TwitterTweetButton
          entity={entity as TwitterTweetButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Carousel:
      return (
        <Carousel
          entity={entity as CarouselInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Faq:
      return (
        <Faq
          entity={entity as FaqInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.PriceElement:
      return (
        <PriceElement
          entity={entity as PriceElementInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Text:
      return (
        <TextNew
          entity={entity as TextInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.ContentTable:
      return (
        <ContentTable
          entity={entity as ContentTableInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Survey:
      return (
        <SurveyNew entity={entity as SurveyInterface} {...additionalProps} />
      )
    case EntityTypeEnum.HorizontalLine:
      return (
        <NewHorizontalLine
          entity={entity as HorizontalLineInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Audio:
      return (
        <AudioNew
          entity={entity as AudioInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.FacebookComments: {
      return (
        <FacebookComments
          entity={entity as FacebookCommentsInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.OptInRecaptcha: {
      return (
        <Recaptcha entity={entity as RecaptchaInterface} {...additionalProps} />
      )
    }
    case EntityTypeEnum.Countdown: {
      return (
        <Countdown entity={entity as CountdownInterface} {...additionalProps} />
      )
    }
    case EntityTypeEnum.CustomerType: {
      return (
        <CustomerTypeNew
          entity={entity as CustomerTypeInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.ContentBox: {
      return (
        <ContentBox
          entity={entity as ContentBoxInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.PaymentMethod: {
      return (
        <PaymentMethod
          entity={entity as PaymentMethodInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Comments:
      return <div />
    case EntityTypeEnum.ShippingFees:
      return (
        <ShippingFees
          entity={entity as ShippingFeesInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.PaymentButton:
      return (
        //@ts-expect-error @TODO harmonize interfaces
        <PaymentButtonNew
          entity={entity as PaymentButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Agreement:
      return (
        <NewAgreement
          entity={entity as AgreementInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteLayoutBody:
      return (
        <WebsiteLayoutBody
          entity={entity as WebsiteLayoutBodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsitePageBody:
      return (
        <WebsitePageBody
          entity={entity as WebsitePageInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteFooter:
      return (
        <WebsiteFooter
          entity={entity as WebsiteFooterInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteHeader:
      return (
        <WebsiteHeader
          entity={entity as WebsiteHeaderInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteLogo:
      return (
        <WebsiteLogo
          entity={entity as WebsiteLogoInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteButton:
      return (
        <WebsiteButton
          entity={entity as WebsiteButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    default: {
      if (process.env.NODE_ENV === 'development') {
        // biome-ignore lint/suspicious/noConsole: <explanation>
        console.warn(`unknown type ${type} of entity id = ${id}`)
        return (
          <div>
            <i className="fas fa-bug" />
            <span> !!! INVALID ENTITY !!!</span>
          </div>
        )
      }

      return <div className="test" />
    }
  }
}
